import { ReactNode } from 'react'
import { cn } from '../../app/utils/cn'

interface CardProps {
  children: ReactNode
  variant?: 'company' | 'company-disabled' | 'default'
  className?: string
  showWatermark?: boolean
}

const LogoBranco = '/logo_branco.svg'
const LOGO_WATERMARK = import.meta.env.VITE_LOGO_SIMULATION

export default function Card({
  children,
  variant = 'default',
  className,
  showWatermark = false,
}: CardProps) {
  return (
    <div
      className={cn(
        'flex flex-col justify-between gap-2 rounded-2xl bg-white02 p-8 ',
        variant.startsWith('company') && 'relative flex-row items-end',
        variant === 'company' && 'cursor-pointer bg-primary text-white',
        variant === 'company-disabled' &&
          'cursor-not-allowed bg-gray01 font-semibold text-black04',
        className,
      )}
    >
      {children}

      {showWatermark && (
        <div
          className={cn(
            'absolute top-3 h-full overflow-hidden',
            LOGO_WATERMARK && 'top-0',
          )}
        >
          {LOGO_WATERMARK ? (
            <img
              src={LOGO_WATERMARK}
              alt="Generic Icon"
              className="h-full w-auto object-contain opacity-20"
            />
          ) : (
            <img
              src={LogoBranco}
              alt="Generic Icon"
              className="h-full w-auto object-contain opacity-20"
            />
          )}
        </div>
      )}
    </div>
  )
}
